import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import SectionHeading from "@/components/base/SectionHeading";

export default function QuickNews() {
  const [feature, ...rest] = newsList.slice(0, 5);

  return (
    <section className="page-wrap mt-14">
      <SectionHeading
        eyebrow="最新资讯"
        title="最新动漫资讯快览"
        description="编辑精选的近期动漫动态，涵盖新番前瞻、深度解读与幕后科普。"
        action={
          <Link
            to="/news"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            查看全部资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Link
          to={`/news/${feature.id}`}
          className="group relative flex min-h-[280px] flex-col justify-end overflow-hidden rounded-lg bg-secondary-900 p-6 md:min-h-[340px]"
        >
          <img
            src={feature.cover}
            alt={`${feature.title} 配图`}
            title={`${feature.title} - 漫蛙2动漫资讯`}
            className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/90 via-secondary-950/40 to-transparent" />
          <div className="relative">
            <span className="inline-block rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
              头条 · {feature.category}
            </span>
            <h3 className="mt-3 text-lg font-bold leading-snug text-background-50 md:text-2xl">{feature.title}</h3>
            <p className="mt-2 line-clamp-2 text-sm text-background-200">{feature.summary}</p>
            <span className="mt-3 block text-xs text-background-300">{feature.date}</span>
          </div>
        </Link>

        <div className="flex flex-col gap-3">
          {rest.map((item) => (
            <Link
              key={item.id}
              to={`/news/${item.id}`}
              className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
            >
              <div className="h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-[72px] md:w-28">
                <img
                  src={item.cover}
                  alt={`${item.title} 配图`}
                  title={`${item.title} - 漫蛙2动漫资讯`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="line-clamp-2 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {item.title}
                </h3>
                <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-400">
                  <span className="text-primary-600">{item.category}</span>
                  <span>·</span>
                  <span>{item.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}